import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useActions } from "../context/actions";
import Seo from "../components/Seo";
import "../components/booth/tokens.css";
import BoothMark from "../components/booth/BoothMark";
import AuthForm from "../components/booth/AuthForm";
import Toast from "../components/booth/Toast";
import Footer from "../components/booth/Footer";
import "./Auth.css";

function Auth() {
  const actions = useActions();
  const navigate = useNavigate();
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("success");

  const notify = useCallback((message, severity = "success") => {
    setToastMessage(message);
    setToastSeverity(severity);
    setToastOpen(true);
  }, []);

  useEffect(() => {
    if (actions.passwordReset) {
      notify("Password reset successfully! You can now log in with your new password.", "success");
      actions.setPasswordReset(false);
    }
  }, [actions, notify]);

  return (
    <div className="booth booth-auth-page">
      <Seo
        title="Log In or Sign Up — The Booth"
        description="Connect your ESPN or Sleeper fantasy football league and start getting AI-written weekly recaps."
        path="/auth"
      />
      <header className="booth-shell booth-auth-masthead">
        <a
          href="/"
          className="booth-auth-mask-link"
          onClick={(e) => {
            e.preventDefault();
            navigate("/");
          }}
        >
          <BoothMark />
        </a>
      </header>
      <main className="booth-shell booth-auth-main">
        <AuthForm onNotify={notify} />
      </main>
      <Footer />
      <Toast
        open={toastOpen}
        message={toastMessage}
        severity={toastSeverity}
        onClose={() => setToastOpen(false)}
      />
    </div>
  );
}

export default Auth;
